import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { Children, type FC, type ReactNode } from "react";

import { useScreenResolution } from "~/hooks/useScreenResolution";

import * as Styled from "./CardsCarousel.styles";
import { DESKTOP_VISIBLE_CARDS, TABLET_VISIBLE_CARDS } from "./constants";
import { useCardsCarousel } from "./useCardsCarousel";

interface ICardsCarouselProps {
  children: ReactNode;
  autoplay?: boolean;
}

export const CardsCarousel: FC<ICardsCarouselProps> = ({
  children,
  autoplay = true,
}) => {
  const theme = useTheme();
  const { isMobile } = useScreenResolution();
  const isTabletRange = useMediaQuery(theme.breakpoints.between("md", "lg"));
  const { emblaRef, scrollPrev, scrollNext } = useCardsCarousel(autoplay);

  const visibleCards = isTabletRange
    ? TABLET_VISIBLE_CARDS
    : DESKTOP_VISIBLE_CARDS;
  const showArrows = !isMobile && Children.count(children) > visibleCards;

  return (
    <Styled.Root>
      {showArrows && (
        <Styled.ScrollArrow
          className="CardsCarouselArrow left"
          onClick={scrollPrev}
        >
          <ChevronLeftIcon />
        </Styled.ScrollArrow>
      )}

      <Styled.Viewport ref={emblaRef}>
        <Styled.Container>{children}</Styled.Container>
      </Styled.Viewport>

      {showArrows && (
        <Styled.ScrollArrow
          className="CardsCarouselArrow right"
          onClick={scrollNext}
        >
          <ChevronRightIcon />
        </Styled.ScrollArrow>
      )}
    </Styled.Root>
  );
};

export const CardsCarouselSlide = Styled.Slide;
